// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --black: #000000;

  --blue-50: #eef8ff;
  --blue-100: #dbf0ff;
  --blue-200: #c1e6ff;
  --blue-400: #3f9cd8;
  --blue-600: #1e4f79;
  --blue-700: #163a59;
  --blue: #0f2c44;

  --teal-100: #dcfffb;
  --teal-200: #b9faf2;
  --teal-500: #1db4a1;
  --teal-700: #0f7b6b;

  --orange: #ff8a3d;

  --red: #d81e5b;
  --red-200: #fff1f6;

  --green-200: #e9fff6;
  --green: #19a870;

  --gray-100: #f2f7fb;
  --gray-200: #e9eff6;
  --gray-300: #c8d4df;
  --gray-400: #6c8094;
  --gray-500: #5b6d7f;
  --gray-600: #3f5162;
  --gray-700: #263848;
  --gray-800: #1b2a36;
  --gray-900: #0f1a23;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  font-family: 'Space Grotesk', sans-serif;
  color: var(--gray-800);
  background:
    radial-gradient(circle at 14% 20%, rgba(29, 180, 161, 0.18), transparent 38%),
    radial-gradient(circle at 88% 14%, rgba(63, 156, 216, 0.18), transparent 42%),
    linear-gradient(165deg, #eff8ff 0%, #f9fcff 55%, #eefdf9 100%);
}

body::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  opacity: 0.28;
  background-image:
    linear-gradient(rgba(30, 79, 121, 0.12) 1px, transparent 1px),
    linear-gradient(90deg, rgba(30, 79, 121, 0.12) 1px, transparent 1px);
  background-size: 54px 54px;
  animation: gridShift 22s linear infinite;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 0.02em;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
a {
  cursor: pointer;
  font-family: 'Space Grotesk', sans-serif;
}

input,
textarea,
section {
  font-family: 'Space Grotesk', sans-serif;
}

p {
  margin: 0;
}

form {
  box-shadow: none !important;
}

.glass-card {
  border: 1px solid rgba(30, 79, 121, 0.16);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.78);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.game-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0f4d4f;
  background: linear-gradient(120deg, var(--teal-100), #ffffff);
  border: 1px solid rgba(15, 123, 107, 0.22);
}

.progress-orb {
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: linear-gradient(145deg, var(--teal-500), var(--blue-400));
  box-shadow: 0 10px 26px rgba(15, 123, 107, 0.28);
  animation: pulseGlow 2.8s ease-in-out infinite;
}

.stagger-enter {
  animation: cardRise 0.5s ease both;
}

.stagger-enter:nth-child(2) {
  animation-delay: 80ms;
}

.stagger-enter:nth-child(3) {
  animation-delay: 160ms;
}

.stagger-enter:nth-child(4) {
  animation-delay: 240ms;
}

@keyframes gridShift {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(54px, 54px, 0);
  }
}

@keyframes pulseGlow {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 10px 26px rgba(15, 123, 107, 0.28);
  }
  50% {
    transform: scale(1.07);
    box-shadow: 0 16px 34px rgba(30, 79, 121, 0.32);
  }
}

@keyframes cardRise {
  from {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@media (max-width: 1080px) {
  html {
    font-size: 93.76%;
  }
}

@media (max-width: 720px) {
  html {
    font-size: 87.5%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;;EAEf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;;EAEjB,cAAc;EACd,kBAAkB;;EAElB,oBAAoB;EACpB,gBAAgB;;EAEhB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB;;;kEAGgE;AAClE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;wEAEsE;EACtE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;;;EAKE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qEAAqE;EACrE,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,mBAAmB;IACnB,gDAAgD;EAClD;EACA;IACE,sBAAsB;IACtB,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\n  --white: #ffffff;\n  --black: #000000;\n\n  --blue-50: #eef8ff;\n  --blue-100: #dbf0ff;\n  --blue-200: #c1e6ff;\n  --blue-400: #3f9cd8;\n  --blue-600: #1e4f79;\n  --blue-700: #163a59;\n  --blue: #0f2c44;\n\n  --teal-100: #dcfffb;\n  --teal-200: #b9faf2;\n  --teal-500: #1db4a1;\n  --teal-700: #0f7b6b;\n\n  --orange: #ff8a3d;\n\n  --red: #d81e5b;\n  --red-200: #fff1f6;\n\n  --green-200: #e9fff6;\n  --green: #19a870;\n\n  --gray-100: #f2f7fb;\n  --gray-200: #e9eff6;\n  --gray-300: #c8d4df;\n  --gray-400: #6c8094;\n  --gray-500: #5b6d7f;\n  --gray-600: #3f5162;\n  --gray-700: #263848;\n  --gray-800: #1b2a36;\n  --gray-900: #0f1a23;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  font-family: 'Space Grotesk', sans-serif;\n  color: var(--gray-800);\n  background:\n    radial-gradient(circle at 14% 20%, rgba(29, 180, 161, 0.18), transparent 38%),\n    radial-gradient(circle at 88% 14%, rgba(63, 156, 216, 0.18), transparent 42%),\n    linear-gradient(165deg, #eff8ff 0%, #f9fcff 55%, #eefdf9 100%);\n}\n\nbody::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.28;\n  background-image:\n    linear-gradient(rgba(30, 79, 121, 0.12) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(30, 79, 121, 0.12) 1px, transparent 1px);\n  background-size: 54px 54px;\n  animation: gridShift 22s linear infinite;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-family: 'Orbitron', sans-serif;\n  letter-spacing: 0.02em;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton,\na {\n  cursor: pointer;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\ninput,\ntextarea,\nsection {\n  font-family: 'Space Grotesk', sans-serif;\n}\n\np {\n  margin: 0;\n}\n\nform {\n  box-shadow: none !important;\n}\n\n.glass-card {\n  border: 1px solid rgba(30, 79, 121, 0.16);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.78);\n  backdrop-filter: blur(10px);\n}\n\n.game-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #0f4d4f;\n  background: linear-gradient(120deg, var(--teal-100), #ffffff);\n  border: 1px solid rgba(15, 123, 107, 0.22);\n}\n\n.progress-orb {\n  width: 64px;\n  height: 64px;\n  border-radius: 999px;\n  background: linear-gradient(145deg, var(--teal-500), var(--blue-400));\n  box-shadow: 0 10px 26px rgba(15, 123, 107, 0.28);\n  animation: pulseGlow 2.8s ease-in-out infinite;\n}\n\n.stagger-enter {\n  animation: cardRise 0.5s ease both;\n}\n\n.stagger-enter:nth-child(2) {\n  animation-delay: 80ms;\n}\n\n.stagger-enter:nth-child(3) {\n  animation-delay: 160ms;\n}\n\n.stagger-enter:nth-child(4) {\n  animation-delay: 240ms;\n}\n\n@keyframes gridShift {\n  0% {\n    transform: translate3d(0, 0, 0);\n  }\n  100% {\n    transform: translate3d(54px, 54px, 0);\n  }\n}\n\n@keyframes pulseGlow {\n  0%,\n  100% {\n    transform: scale(1);\n    box-shadow: 0 10px 26px rgba(15, 123, 107, 0.28);\n  }\n  50% {\n    transform: scale(1.07);\n    box-shadow: 0 16px 34px rgba(30, 79, 121, 0.32);\n  }\n}\n\n@keyframes cardRise {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 16px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@media (max-width: 1080px) {\n  html {\n    font-size: 93.76%;\n  }\n}\n\n@media (max-width: 720px) {\n  html {\n    font-size: 87.5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
